import { defineNuxtPlugin } from '#app/nuxt'
import { LazyProseEm, LazyProseScript } from '#components'
const lazyGlobalComponents = [
  ["ProseEm", LazyProseEm],
["ProseScript", LazyProseScript],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
